import { render, staticRenderFns } from "./Dots.vue?vue&type=template&id=a8c3269a&scoped=true&"
import script from "./Dots.vue?vue&type=script&lang=js&"
export * from "./Dots.vue?vue&type=script&lang=js&"
import style0 from "./Dots.vue?vue&type=style&index=0&id=a8c3269a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c3269a",
  null
  
)

export default component.exports